import Vue from 'vue';

import VueLogger from 'vue-logger';
Vue.use(VueLogger, {
    prefix: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
    dev: process.env.NODE_ENV === 'development',
    shortname: false,
    levels: ['log', 'warn', 'debug', 'error', 'dir']
});

import Quizz from './components/Quizz.vue';

import './assets/scss/style.scss';

const appQuizz = new Vue({
    el: '#app-quizz',
    render: h => h(Quizz)
});


// WEBPACK FOOTER //
// ./src/main.js